import React from 'react';

import { Box, Stack, Text } from '@chakra-ui/react';

export const formatTooltip = ({
  header,
  content,
  width = 32,
  spacing = 2,
  minWidth = 32,
}) => {
  return (
    <Stack w={width} spacing={spacing} minW={minWidth}>
      <Box
        borderBottom="1px solid"
        borderColor="orange"
        color="orange"
        w="full"
        textAlign="left"
      >
        {header}
      </Box>
      <Box w="full" textAlign="left">
        {content}
      </Box>
    </Stack>
  );
};

export const renderTooltipFieldValue = (field: string, value: any) => {
  return (
    <Text>
      <Text color="orange" display="inline-block" whiteSpace="nowrap">
        {field}:
      </Text>{' '}
      {value}
    </Text>
  );
};
